<template>
  <div class="tw:flex tw:flex-col tw:gap-6">
    <div class="tw:flex tw:flex-wrap tw:sm:flex-nowrap tw:gap-2 tw:justify-between tw:items-center">
      <p class="tw:heading-2 tw:text-black">{{ trans._products.content.drawer.profitability }}</p>
      <div class="tw:w-[14rem]">
        <EdroneDatepicker
          :disabled-date="disabledWithToday"
          :value="[dateFrom, dateTo]"
          type="range"
          :shortcuts="datesDatepickerShortcutsWithoutToday"
          @input="(event) => emit('changeDate', event)"
        />
      </div>
    </div>

    <div class="tw:flex tw:flex-col tw:sm:flex-row tw:sm:flex-nowrap tw:gap-2 tw:sm:justify-between">
      <ProductReportAnalyticsProfitabilityBox
        :label="trans._products.content.drawer.orders"
        :value="orders"
        :is-loading="isLoading"
      />

      <ProductReportAnalyticsProfitabilityBox
        :label="trans._products.content.drawer.orderedCopies"
        :value="orderedCopies"
        :is-loading="isLoading"
      />

      <ProductReportAnalyticsProfitabilityBox
        :label="trans._products.content.drawer.revenue"
        :value="revenue"
        :is-loading="isLoading"
      />
    </div>

    <ProductReportAnalyticsChart
      :statistics="statistics"
      :ordered="orders"
      :viewed="viewed"
      :added-to-cart="addedToCart"
      :conversion-added-to-cart="conversionAddedToCart"
      :conversion-ordered="conversionOrdered"
      :is-loading="isLoading"
    />
  </div>
</template>

<script setup lang="ts">
import { DTODailyTrackerProductStatistic } from "vue-app/api/dto";
import ProductReportAnalyticsProfitabilityBox from "./ProductReportAnalyticsProfitabilityBox.vue";
import ProductReportAnalyticsChart from "./ProductReportAnalyticsChart.vue";
import EdroneDatepicker from "edrone-components/EdroneDatepicker.vue";
import { disabledWithToday } from "vue-app/datesDatepicker/datesDatepicker";
import { datesDatepickerShortcutsWithoutToday } from "vue-app/datesDatepicker/datesDatepickerShortcuts";

interface Props {
  orders: number | null;
  orderedCopies: number | null;
  revenue: string | null;
  viewed: number | null;
  addedToCart: number | null;
  conversionAddedToCart: number | null;
  conversionOrdered: number | null;
  isLoading: boolean;
  statistics: DTODailyTrackerProductStatistic[];
  dateFrom: Date;
  dateTo: Date;
}

defineProps<Props>();
const emit = defineEmits(["changeDate"]);
</script>

<style lang="scss">
.mx-datepicker-popup {
  z-index: 999999999999 !important;
}
</style>
